// import React, { useState, useEffect } from 'react';
// import { Container, Row, Col, Card, Spinner, Alert, ListGroup, Badge } from 'react-bootstrap';
// import api from '../utils/api';
// import { useNavigate } from 'react-router-dom';

// const Dashboard = () => {
//     const [bookings, setBookings] = useState([]);
//     const [userProfile, setUserProfile] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const navigate = useNavigate();

//     const userId = localStorage.getItem('userId');

//     useEffect(() => {
//         if (!userId) {
//             navigate('/login');
//             return;
//         }

//         const fetchDashboardData = async () => {
//             try {
//                 // Fetch user profile details
//                 const profileResponse = await api.get(`/users/${userId}`);
//                 setUserProfile(profileResponse.data);

//                 // Fetch user bookings history
//                 const bookingsResponse = await api.get(`/users/${userId}/bookings`);
//                 setBookings(bookingsResponse.data);
//             } catch (err) {
//                 setError('Failed to fetch dashboard data. Please try again.');
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchDashboardData();
//     }, [userId, navigate]);

//     const getStatusVariant = (status) => {
//         switch (status) {
//             case 'Pending':
//                 return 'warning';
//             case 'Active':
//                 return 'success';
//             case 'Completed':
//                 return 'secondary';
//             case 'Canceled':
//                 return 'danger';
//             default:
//                 return 'info';
//         }
//     };

//     if (loading) {
//         return (
//             <Container className="my-5 text-center">
//                 <Spinner animation="border" />
//                 <p className="mt-2">Loading your dashboard...</p>
//             </Container>
//         );
//     }

//     if (error) {
//         return (
//             <Container className="my-5">
//                 <Alert variant="danger">{error}</Alert>
//             </Container>
//         );
//     }

//     return (
//         <Container className="my-5">
//             <h2 className="mb-4 text-center">User Dashboard</h2>
//             <Row>
//                 {/* User Profile Card */}
//                 <Col md={{ span: 8, offset: 2 }} className="mb-4">
//                     <Card className="shadow-sm">
//                         <Card.Header>My Profile</Card.Header>
//                         <Card.Body>
//                             <Card.Title>{userProfile?.name}</Card.Title>
//                             <Card.Subtitle className="mb-2 text-muted">{userProfile?.email}</Card.Subtitle>
//                             <Card.Text className="mt-3">
//                                 <strong>Subscription Status:</strong>{' '}
//                                 <Badge bg={userProfile?.subscription?.isSubscriptionActive ? 'success' : 'danger'}>
//                                     {userProfile?.subscription?.isSubscriptionActive ? 'Active' : 'Inactive'}
//                                 </Badge>
//                                 {userProfile?.subscription?.isSubscriptionActive && (
//                                     <p className="mb-0 mt-2">Next Payment Date: {new Date(userProfile?.subscription?.nextPaymentDate).toLocaleDateString()}</p>
//                                 )}
//                             </Card.Text>
//                         </Card.Body>
//                     </Card>
//                 </Col>

//                 {/* Booking History Card */}
//                 <Col md={{ span: 8, offset: 2 }}>
//                     <Card className="shadow-sm">
//                         <Card.Header>Booking History</Card.Header>
//                         <Card.Body>
//                             {bookings.length === 0 ? (
//                                 <Alert variant="info">You have no bookings yet.</Alert>
//                             ) : (
//                                 <ListGroup variant="flush">
//                                     {bookings.map((booking) => (
//                                         <ListGroup.Item key={booking._id} className="d-flex justify-content-between align-items-start">
//                                             <div>
//                                                 <h5>Seat {booking.seatNumber}</h5>
//                                                 <p className="mb-1">
//                                                     From: {new Date(booking.startTime).toLocaleString()}
//                                                 </p>
//                                                 <p className="mb-0">
//                                                     To: {new Date(booking.endTime).toLocaleString()}
//                                                 </p>
//                                             </div>
//                                             <Badge pill bg={getStatusVariant(booking.status)} className="p-2">
//                                                 {booking.status}
//                                             </Badge>
//                                         </ListGroup.Item>
//                                     ))}
//                                 </ListGroup>
//                             )}
//                         </Card.Body>
//                     </Card>
//                 </Col>
//             </Row>
//         </Container>
//     );
// };

// export default Dashboard;


import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Alert, ListGroup, Badge, Button } from 'react-bootstrap';
import api from '../utils/api';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
    const [bookings, setBookings] = useState([]);
    const [userProfile, setUserProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const userId = localStorage.getItem('userId');

    useEffect(() => {
        if (!userId) {
            navigate('/login');
            return;
        }

        const fetchDashboardData = async () => {
            try {
                const profileResponse = await api.get(`/users/${userId}`);
                setUserProfile(profileResponse.data);

                const bookingsResponse = await api.get(`/users/${userId}/bookings`);
                setBookings(bookingsResponse.data);
                
            } catch (err) {
                setError('Failed to fetch dashboard data. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        fetchDashboardData();
    }, [userId, navigate]);

    // This function simply navigates to the homepage
    const handleBookAgain = (booking) => {
        // You can pass the seat ID as state to pre-select it on the homepage
        navigate('/', { state: { seatIdToSelect: booking.seatId } });
    };

    const getStatusVariant = (status) => {
        switch (status) {
            case 'Pending':
                return 'warning';
            case 'Active':
                return 'success';
            case 'Completed':
                return 'secondary';
            case 'Canceled':
                return 'danger';
            default:
                return 'info';
        }
    };

    const isBookingExpired = (booking) => {
        const now = new Date();
        const endTime = new Date(booking.endTime);
        return booking.status === 'Active' && endTime < now;
    };

    if (loading) {
        return (
            <Container className="my-5 text-center">
                <Spinner animation="border" />
                <p className="mt-2">Loading your dashboard...</p>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="my-5">
                <Alert variant="danger">{error}</Alert>
            </Container>
        );
    }

    return (
        <Container className="my-5">
            <h2 className="mb-4 text-center">User Dashboard</h2>
            <Row>
                <Col md={{ span: 8, offset: 2 }} className="mb-4">
                    <Card className="shadow-sm">
                        <Card.Header>My Profile</Card.Header>
                        <Card.Body>
                            <Card.Title>{userProfile?.name}</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">{userProfile?.email}</Card.Subtitle>
                            <Card.Text className="mt-3">
                                <strong>Subscription Status:</strong>{' '}
                                <Badge bg={userProfile?.subscription?.isSubscriptionActive ? 'success' : 'danger'}>
                                    {userProfile?.subscription?.isSubscriptionActive ? 'Active' : 'Inactive'}
                                </Badge>
                                {userProfile?.subscription?.isSubscriptionActive && (
                                    <p className="mb-0 mt-2">Next Payment Date: {new Date(userProfile?.subscription?.nextPaymentDate).toLocaleDateString()}</p>
                                )}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={{ span: 8, offset: 2 }}>
                    <Card className="shadow-sm">
                        <Card.Header>Booking History</Card.Header>
                        <Card.Body>
                            {bookings.length === 0 ? (
                                <Alert variant="info">You have no bookings yet.</Alert>
                            ) : (
                                <ListGroup variant="flush">
                                    {bookings.map((booking) => (
                                        <ListGroup.Item key={booking._id} className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5>Seat {booking.seatNumber}</h5>
                                                <h9>Slot Name {booking.slotName}</h9>
                                                <p className="mb-1">
                                                    From: {new Date(booking.startTime).toLocaleString()}
                                                </p>
                                                <p className="mb-0">
                                                    To: {new Date(booking.endTime).toLocaleString()}
                                                </p>
                                            </div>
                                            <div>
                                                {isBookingExpired(booking) ? (
                                                    <Button
                                                        variant="primary"
                                                        size="sm"
                                                        onClick={() => handleBookAgain(booking)}
                                                    >
                                                        Book Again
                                                    </Button>
                                                ) : (
                                                    <Badge pill bg={getStatusVariant(booking.status)} className="p-2">
                                                        {booking.status}
                                                    </Badge>
                                                )}
                                            </div>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Dashboard;